export default __webpack_public_path__ + "static/call-center-new-3a073d14d2c3f4b8b5e2d57f15aa96cb.png";